import type { Embedding } from '@shared/utils/search';
import { cosineSimilarity } from '@shared/utils/search';

export { cosineSimilarity };

export function colorSimilarity(term: Embedding, colors: Readonly<[Embedding, Embedding, Embedding]> | [], white: Embedding, beige: Embedding) {
  if (colors.length === 0) return 0;

  // color75: Dominant color, 75% by area
  // color20: Secondary color, 20% by area
  // colof05: Accent color. 5% but still has visual impact.
  const [color75, color20, color05] = colors;

  const weightedAverage = color75.map((c75, i) => {
    const c20 = color20[i];
    const c05 = color05[i];

    // Most cards are on a white or beige background.
    // In these cases the Secondary Color (color20) is promoted to primary.
    // However, not so much as to compete with a card that has a true full-color background.
    // Thus 0.7 instead of the full 0.75
    // Note: Our vectors are effectively interned thus comparable by ref.
    if (color75 === beige) return c20 * 0.7 + c75 * 0.3 + c05 * 0.05;
    if (color75 === white) return c20 * 0.75 + c75 * 0.2 + c05 * 0.05;
    return c75 * 0.75 + c20 * 0.2 + c05 * 0.05;
  });

  return cosineSimilarity(term, weightedAverage);
}
